import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Projects from '../../api/projects'

import Shape from '../../images/right-arrow-2.svg'

const ClickHandler = () => {
  window.scrollTo(0, 0)
}

const ProjectSection = (props) => {
  const [activeCategory, setActiveCategory] = useState('all')

  // Get unique categories from projects
  const categories = [
    'all',
    ...new Set(Projects.map((project) => project.subTitle)),
  ]

  // Create category mapping for display names
  const categoryNames = {
    e: 'Exterior Design',
    i: 'Interior Design',
    c: 'Construction',
    all: 'All',
  }

  // Filter projects based on active category
  const filteredProjects =
    activeCategory === 'all'
      ? Projects
      : Projects.filter((project) => project.subTitle === activeCategory)
  return (
    // <section className={'' + props.hclass}>
    //   <div className="container">
    //     <div className="title">
    //       <h2 className="fade_bottom">Our Projects</h2>
    //     </div>
    //     <div className="project-wrap">
    //       {Projects.map((project, item) => (
    //         <div className="project-card fade_bottom" key={item}>
    //           <img src={project.pimg} alt="project-1" />
    //           <img src={project.pimg} alt="project-1" />
    //           <div className="content">
    //             <h2>
    //               {/* <Link onClick={ClickHandler} to={`/project-single/${project.slug}`}> */}
    //               {project.title}
    //               {/* </Link> */}
    //             </h2>
    //             <span>{project.subtitle}</span>
    //           </div>
    //         </div>
    //       ))}
    //     </div>
    //     <div className="project-allBtn fade_bottom">
    //       <Link onClick={ClickHandler} to="/projects" className="theme-btn">
    //         <span>See All Projects</span>
    //         <img src={Shape} alt="" />
    //       </Link>
    //     </div>
    //   </div>
    // </section>
    <section className={'' + props.hclass}>
      <div className="container">
        <div className="title">
          {/* <h2 className="fade_bottom">Our Projects</h2> */}
        </div>

        <div className="category-filters fade_bottom">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={activeCategory === category ? 'active' : ''}
            >
              {categoryNames[category]}
            </button>
          ))}
        </div>

        <div className="project-wrap">
          {filteredProjects.map((project, item) => (
            <div className="project-card fade_bottom" key={item}>
              <img src={project.pimg} alt="project-1" />
              <img src={project.pimg} alt="project-1" />
              <div className="content">
                <h2>
                  {/* <Link onClick={ClickHandler} to={`/project-single/${project.slug}`}> */}
                  {project.title}
                  {/* </Link> */}
                </h2>
                <span>{project.subtitle}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="project-allBtn fade_bottom">
          <Link onClick={ClickHandler} to="/projects" className="theme-btn">
            <span>See All Projects</span>
            <img src={Shape} alt="" />
          </Link>
        </div>
      </div>
    </section>
  )
}
export default ProjectSection
